export default __webpack_public_path__ + "static/media/carbon_in-progress.cc04a0b8.svg";